import React from 'react';
import { useSelector } from 'react-redux';
import { ZoomIn, ZoomOut } from '@mui/icons-material';
import { Button, List, Skeleton, Stack } from '@mui/material';
import { GlobalVariables } from '../../../../pdf/GlobalVariables';
import { ReduxUpdater } from '../../../../pdf/ReduxUpdater';
import { thumbnailSize } from '../../../../Redux/SelectedSidepanelSlice';

import styles from './Thumbnails.module.scss';
import i18next from 'i18next';
import { ApryseSDK } from '../../../../pdf/ApryseSDK';

export default () => {
    const scaleLevels = ['16%', '21%', '29.9%', '46%', '-webkit-fill-available'];
    const scaleLevel = useSelector(thumbnailSize) as number;
    const [thumbnails, setThumbnails] = React.useState<string[]>([]);

    const batchSize = 10;
    const pageNumbers = [...Array(ApryseSDK.pageCount).keys()].map(i => i + 1);

    React.useMemo(async () => {
        let generatedThumbnails: string[] = [];
        while (pageNumbers.length) {
            const pages = pageNumbers.splice(0, batchSize);
            generatedThumbnails = generatedThumbnails.concat(
                await Promise.all(pages.map(pageNr => ApryseSDK.loadThumbnail(pageNr))),
            );
            setThumbnails(generatedThumbnails);
        }
    }, []);

    const menu = (
        <Stack className={styles.sidebarMenuArea} direction="row" spacing={1} pl={2} pr={2}>
            <Button
                id={GlobalVariables.isForTestRun ? 'thumbnailsSidebarMenuBtnZoomOut' : undefined}
                className={styles.iconButton}
                onClick={() => (ReduxUpdater.thumbnailSize = Math.max(scaleLevel - 1, 0))}
                disabled={scaleLevel <= 0}
                variant="outlined"
            >
                <ZoomOut />
            </Button>
            <Button
                id={GlobalVariables.isForTestRun ? 'thumbnailsSidebarMenuBtnZoomIn' : undefined}
                className={styles.iconButton}
                onClick={() =>
                    (ReduxUpdater.thumbnailSize = Math.min(scaleLevel + 1, scaleLevels.length - 1))
                }
                disabled={scaleLevel >= scaleLevels.length - 1}
                variant="outlined"
            >
                <ZoomIn />
            </Button>
        </Stack>
    );

    const pageThumbnail = (pageNr: number) => {
        const base64Data = thumbnails[pageNr - 1];

        return (
            <div
                key={`pageThumb-${pageNr}`}
                className={styles.thumbnailCard}
                style={{
                    width: `${scaleLevels[scaleLevel]}`,
                }}
                onClick={() => ApryseSDK.documentViewer.setCurrentPage(pageNr, true)}
            >
                {base64Data ? (
                    <img alt="" className={styles.thumbnail} src={base64Data} loading="lazy" />
                ) : (
                    <Skeleton
                        className={styles.thumbnail}
                        width={142}
                        height={185}
                        key={pageNr.toString()}
                        variant="rectangular"
                        animation="wave"
                    />
                )}
                <p style={{ textAlign: 'center' }}>
                    {i18next.t('thumbnailsPanel.page', { page: pageNr })}
                </p>
            </div>
        );
    };

    return (
        <Stack>
            {menu}
            <List className={styles.resultList} component="nav" style={{ overflow: 'auto' }}>
                {pageNumbers.map(pageNr => pageThumbnail(pageNr))}
            </List>
        </Stack>
    );
};
